import { Component, OnInit } from '@angular/core';
import { AuthGuardService } from '../../../shared/services/auth-guard.service'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  // sessionFullName;

  constructor(
    // private authGuardService: AuthGuardService
  ) { }

  ngOnInit() {
  //  this.setFullName()
  }

  setFullName(){
    // let userProfile = this.authGuardService.getUserProfileInformation()
    // console.log('header')
    // console.log(userProfile)
    // this.sessionFullName = `${userProfile.name} ${userProfile.surname}`
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/header/header.component.ts